// extracted by mini-css-extract-plugin
export default {"container":"deliveryOrderDataList_container__5HQA4","actions":"deliveryOrderDataList_actions__XWnoJ"};